var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.makeCall}},[_c('v-icon',{domProps:{"textContent":_vm._s('$phoneAlt')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }